"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectIsIssuerEvaluationHandler = void 0;
const pex_models_1 = require("@sphereon/pex-models");
const ConstraintUtils_1 = require("../../ConstraintUtils");
const Messages_1 = __importDefault(require("../../types/Messages"));
const utils_1 = require("../../utils");
const abstractEvaluationHandler_1 = require("./abstractEvaluationHandler");
class SubjectIsIssuerEvaluationHandler extends abstractEvaluationHandler_1.AbstractEvaluationHandler {
    constructor(client) {
        super(client);
    }
    getName() {
        return 'SubjectIsIssuerEvaluation';
    }
    handle(pd, wrappedVcs) {
        // PresentationDefinitionV2 is the common denominator
        pd.input_descriptors.forEach((inputDescriptor, index) => {
            const constraints = inputDescriptor.constraints;
            if ((constraints === null || constraints === void 0 ? void 0 : constraints.subject_is_issuer) === pex_models_1.Optionality.Required) {
                this.checkSubjectIsIssuer(inputDescriptor.id, wrappedVcs, index);
            }
            else {
                this.getResults().push(...wrappedVcs.map((_, vcIndex) => this.generateSuccessResult(index, `$[${vcIndex}]`, 'not applicable')));
            }
        });
        this.updatePresentationSubmission(pd);
    }
    checkSubjectIsIssuer(inputDescriptorId, wrappedVcs, idIdx) {
        this.client.presentationSubmission.descriptor_map.forEach((currentDescriptor) => {
            var _a, _b;
            if (currentDescriptor.id === inputDescriptorId) {
                const vc = utils_1.JsonPathUtils.extractInputField(wrappedVcs.map((wvc) => wvc.internalCredential), [currentDescriptor.path]);
                if (((_a = vc[0]) === null || _a === void 0 ? void 0 : _a.value.issuer) === ((_b = vc[0]) === null || _b === void 0 ? void 0 : _b.value.credentialSubject.id)) {
                    this.getResults().push(this.generateSuccessResult(idIdx, currentDescriptor.path));
                }
                else {
                    this.getResults().push(this.generateErrorResult(idIdx, currentDescriptor.path));
                }
            }
        });
    }
    generateErrorResult(idIdx, vcPath) {
        return {
            input_descriptor_path: `$.input_descriptors[${idIdx}]`,
            evaluator: this.getName(),
            status: ConstraintUtils_1.Status.ERROR,
            message: Messages_1.default.SUBJECT_IS_NOT_ISSUER,
            verifiable_credential_path: vcPath,
        };
    }
    generateSuccessResult(idIdx, vcPath, message) {
        return {
            input_descriptor_path: `$.input_descriptors[${idIdx}]`,
            evaluator: this.getName(),
            status: ConstraintUtils_1.Status.INFO,
            message: message !== null && message !== void 0 ? message : Messages_1.default.SUBJECT_IS_ISSUER,
            verifiable_credential_path: vcPath,
        };
    }
}
exports.SubjectIsIssuerEvaluationHandler = SubjectIsIssuerEvaluationHandler;
